import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm, } from 'redux-form';
import { listar } from '../../actions'


const mapStateToProps = ({ CriarCustomFormReducer }, props) => {
    const { loading, lista } = CriarCustomFormReducer.rLista;
    let listaFinal = [];
    if (lista) {
        listaFinal = lista.slice()
    }
    
    return { loadingListaPesquisa: loading, listaPesquisa: listaFinal };
};


export default compose(
    connect(mapStateToProps, { listar }),
    reduxForm({
        form: 'CriarCustomPesquisa',
    })
);





// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/components/CriarCustomPesquisa/CriarCustomPesquisa.enhancer.js